<template>
  <div v-if="editor">
    <div class="row justify-center">
      <Toolbar
        v-if="editor"
        :editor="editor"
        :style="`width: ${barWidth ? barWidth : 'calc(100vw - 200px)'};`"
      />
    </div>
    <div class="row justify-center">
      <div
        :style="`
          border: 1px solid grey;
          border-radius: 10px;
          width: ${borderWidth ? borderWidth : 'calc(100vw - 190px)'};
          height: 100%;
          padding-left: 30px;
          padding-right: 30px;
        `"
      >
        <q-scroll-area
        :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
          :style="`height: calc(100vh - 350px); width: ${
            contentWidth ? contentWidth : 'calc(100vw - 200px)'
          };`"
        >
          <editor-content
            v-if="editor"
            class="editor__content"
            style="border: 0px"
            :editor="editor"
          />
        </q-scroll-area>
      </div>
    </div>
    <bubble-menu
      v-if="editor"
      :editor="editor"
      :tippy-options="{ duration: 100 }"
    >
      <!-- <q-btn> This is a test </q-btn> -->
    </bubble-menu>
  </div>
</template>

<script>
// import { UiMixin } from "@/mixins/tiptap";
import Toolbar from "./toolbar.vue";
import { Editor, EditorContent, BubbleMenu } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
// import Blockquote from "@tiptap/extension-blockquote";
// import CodeBlock from "@tiptap/extension-codeBlock";
// import HardBreak from "@tiptap/extension-hardBreak";
// import Heading from "@tiptap/extension-heading";
// import HorizontalRule from "@tiptap/extension-horizontalRule";
// import OrderedList from "@tiptap/extension-orderedList";
// import BulletList from "@tiptap/extension-bulletList";
// import ListItem from "@tiptap/extension-listItem";
// import TodoItem from "@tiptap/extension-todoItem";
// import TodoList from "@tiptap/extension-todoList";
// import Bold from "@tiptap/extension-bold";
// import Code from "@tiptap/extension-code";
// import Italic from "@tiptap/extension-italic";
// import Link from "@tiptap/extension-link";
// import Strike from "@tiptap/extension-strike";
// import Underline from "@tiptap/extension-underline";
// import History from "@tiptap/extension-history";
export default {
  components: {
    EditorContent,
    Toolbar,
    BubbleMenu,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    contentWidth: {
      type: String,
      default: null,
    },
    barWidth: {
      type: String,
      default: null,
    },
    borderWidth: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    value: function () {
      const isSame = this.editor.getHTML() === this.value;

      if (isSame) {
        return;
      }

      this.editor.commands.setContent(this.value, false);
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  mounted() {
    this.editor = new Editor({
      extensions: [StarterKit, Link.configure({ openOnClick: false })],
      content: this.value === "" || !this.value ? "Type Here..." : this.value,
      onUpdate: () => {
        this.$emit("input", this.editor.getHTML());
      },
    });
  },
  methods: {},
};
</script>
